import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocationAutosuggest } from '@classes/location-autosuggest.class';
import { Member } from '@components/members';
import { CcssService } from '@services/ccss/ccss.service';
import { Observable } from 'rxjs';
import { MobileAutosuggestOverlayComponent } from '../mobile-autosuggest-overlay';
import { NetworkSelectionDropdownService } from '@services/network-selection-dropdown/network-selection-dropdown.service';

@Component({
  selector: 'app-network-location-members',
  templateUrl: './network-location-members.component.html',
})
export class NetworkLocationMembersComponent implements OnInit, OnChanges {
  @Input() public authStatus: boolean = false;
  @Input() public isMobile: boolean;
  @Input() public isHomePage: boolean = false;
  @Input() public isBillingCodeSearch: boolean = false;
  @Input() public member: Member;

  public networkSelectionDropdownEnabled: Observable<boolean>;
  public showMembersDropdown: boolean;

  constructor(
    public ccssService: CcssService,
    public locationAutosuggest: LocationAutosuggest,
    private dialog: MatDialog,
    private networkSelectionDropdownService: NetworkSelectionDropdownService
  ) {}

  ngOnInit(): void {
    this.networkSelectionDropdownEnabled =
      this.networkSelectionDropdownService.getNetworkSelectionDropdownConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.member) {
      this.showMembersDropdown =
        this.authStatus && this.member?.dependents?.length > 1;
    }
  }

  public openMobileAutosuggest() {
    this.dialog.open(MobileAutosuggestOverlayComponent, {
      backdropClass: 'fullscreen-overlay-autosuggest',
      panelClass: 'fullscreen-overlay',
      height: '100%',
      restoreFocus: false,
      data: { locationSelected: true },
    });
  }
}
